(function () {
    'use strict';

    angular.module('wamasysApp').factory('MobileMessage', MobileMessage);
    MobileMessage.$inject = ['$resource'];

    function MobileMessage($resource) {
        return $resource('api/mobile-messages/:id', {id: '@id'}, {
            query: {method: 'GET', isArray: true},
            create: {method: 'POST'},
            users: {method: 'GET', url: 'api/mobile-messages/users', isArray: true},
            diagnostics: {method: 'GET', url: 'api/mobile-messages/diagnostics'},
            recipients: {method: 'GET', url: 'api/mobile-messages/:id/recipients', isArray: true}
        });
    }
})();
